export default "__VITE_ASSET__fb216cdc__"